import { ExtNotSupportError } from '@hyext-inner/ext-web-comp'

let sharedInstance: HyExtComp = null

export default class HyExtComp {
  hyExtCompInLiveRoom: IHyExtCompInLiveRoom
  hyExtCompInTT: IHyExtCompInTT
  hyExtCompInHdWrapper: IHyExtCompInTT
  static getSharedInstance() {
    if (sharedInstance) {
      return Promise.resolve(sharedInstance)
    } else {
      sharedInstance = new HyExtComp()
      if (process.env.NODE_ENV === 'development') {
        // @ts-ignore
        window.hyExtComp = sharedInstance
      }
      return Promise.resolve(sharedInstance)
    }
  }
  async init(options: HyExtCompInLiveRoomInitOptions) {
    try {
      if (!this.hyExtCompInLiveRoom) {
        const { default: HyExtCompInLiveRoomCtor } = await import('./modules/comps/HyExtCompInLiveRoom' /* webpackChunkName: "web-comp-in-live-room" */)
        const hyExtCompInLiveRoom = new HyExtCompInLiveRoomCtor()
        await hyExtCompInLiveRoom.init(options)
        this.hyExtCompInLiveRoom = hyExtCompInLiveRoom
      }
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        return Promise.reject(err)
      }
    }
  }
  async initInTT(options: HyExtCompInTTInitOptions) {
    try {
      if (!this.hyExtCompInTT) {
        const { default: HyExtCompInTTCtor } = await import('./modules/comps/HyExtCompInTT' /* webpackChunkName: "web-comp-in-tt" */)
        const hyExtCompInTT = new HyExtCompInTTCtor()
        await hyExtCompInTT.init(options)
        this.hyExtCompInTT = hyExtCompInTT
      }
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        return Promise.reject(err)
      }
    }
  }
  async initInHdWrapper(options: HyExtCompInTTInitOptions) {
    try {
      if (!this.hyExtCompInHdWrapper) {
        const { default: HyExtCompInHdWrapper } = await import('./modules/comps/HyExtCompInHdWrapper' /* webpackChunkName: "web-comp-in-hd-wrapper" */)
        const hyExtCompInHdWrapper = new HyExtCompInHdWrapper()
        await hyExtCompInHdWrapper.init(options)
        this.hyExtCompInHdWrapper = hyExtCompInHdWrapper
      }
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        return Promise.reject(err)
      }
    }
  }
  getWebInnerIFrame(extUuid: string, inLiveRoom?: boolean, inHdWrapper?: boolean, withDimension?: boolean): Promise<any> {
    if (!inLiveRoom) {
      if (!inHdWrapper) {
        if (!this.hyExtCompInTT) {
          return Promise.reject(new ExtNotSupportError('请先执行initInTT'))
        } else {
          return this.hyExtCompInTT.getWebInnerIFrame(extUuid)
        }
      } else {
        if (!this.hyExtCompInHdWrapper) {
          return Promise.reject(new ExtNotSupportError('请先执行initInHdWrapper'))
        } else {
          return this.hyExtCompInHdWrapper.getWebInnerIFrame(extUuid, withDimension)
        }
      }
    } else {
      if (!this.hyExtCompInLiveRoom) {
        return Promise.reject(new ExtNotSupportError('请先执行initIn'))
      } else {
        return this.hyExtCompInLiveRoom.getWebInnerIFrame(extUuid)
      }
    }
  }
  showPanel(extUuid: string, query?: string): Promise<void> {
    if (!this.hyExtCompInLiveRoom) {
      return Promise.reject(new ExtNotSupportError('请先执行init'))
    } else {
      return this.hyExtCompInLiveRoom.showPanel(extUuid, query)
    }
  }
  loadPopup(extUuid: string, query?: string): Promise<void> {
    if (!this.hyExtCompInLiveRoom) {
      return Promise.reject(new ExtNotSupportError('请先执行init'))
    } else {
      return this.hyExtCompInLiveRoom.loadPopup(extUuid, query)
    }
  }
  onLocalMessage(extUuid: string, eventName: string, extType: string, handler: (message: string) => void, inLiveRoom?: boolean): Promise<void> {
    if (!inLiveRoom) {
      if (!this.hyExtCompInTT) {
        return Promise.reject(new ExtNotSupportError('请先执行initInTT'))
      } else {
        return this.hyExtCompInTT.onLocalMessage(extUuid, eventName, extType, handler)
      }
    } else {
      if (!this.hyExtCompInLiveRoom) {
        return Promise.reject(new ExtNotSupportError('请先执行initIn'))
      } else {
        return this.hyExtCompInLiveRoom.onLocalMessage(extUuid, eventName, extType, handler)
      }
    }
  }
  offLocalMessage(extUuid: string, eventName: string, extType: string, handler: (message: string) => void, inLiveRoom?: boolean): Promise<void> {
    if (!inLiveRoom) {
      if (!this.hyExtCompInTT) {
        return Promise.reject(new ExtNotSupportError('请先执行initInTT'))
      } else {
        return this.hyExtCompInTT.offLocalMessage(extUuid, eventName, extType, handler)
      }
    } else {
      if (!this.hyExtCompInLiveRoom) {
        return Promise.reject(new ExtNotSupportError('请先执行initIn'))
      } else {
        return this.hyExtCompInLiveRoom.offLocalMessage(extUuid, eventName, extType, handler)
      }
    }
  }
  postLocalMessage(extUuid: string, eventName: string, extType: string, message: string, inLiveRoom?: boolean): Promise<void> {
    if (!inLiveRoom) {
      if (!this.hyExtCompInTT) {
        return Promise.reject(new ExtNotSupportError('请先执行initInTT'))
      } else {
        return this.hyExtCompInTT.postLocalMessage(extUuid, eventName, extType, message)
      }
    } else {
      if (!this.hyExtCompInLiveRoom) {
        return Promise.reject(new ExtNotSupportError('请先执行initIn'))
      } else {
        return this.hyExtCompInLiveRoom.postLocalMessage(extUuid, eventName, extType, message)
      }
    }
  }
}